import { message } from 'antd'
import axios from 'axios'
import API from '@api/api.js';
import {
    SEGMENT_ALGO_TYPE,
} from "@utils/CONST"

// 获取tryonmaskId
const getClothMaskId = async (imageUrl) => {
    try {
        const res = await API.maskPredictionAicloth({
            image: imageUrl,
            mask_style: 3,
        })
        if (res.code != 0) throw new Error(res.message)
        return `${SEGMENT_ALGO_TYPE.AICLOTH_MASK}:${res.data}`
    } catch (err) {
        console.log(err)
        message.warning(err?.message)
        return false
    }
}
// 获取tryonshoesid
const getShoesMaskId = async (imageUrl) => {
    try {
        const res = await await API.maskPredictionshoes({
            ref_img: imageUrl
        })
        if (res.code != 0) throw new Error(res.message)
        return `${SEGMENT_ALGO_TYPE.AISHOES_MASK}:${res.data}`
    } catch (err) {
        console.log(err)
        message.warning(err?.message)
        return false
    }
}
// 获取眼镜maskid
const getGlassesMaskId = async (imageUrl) => {
    try {
        const res = await await API.maskPredictionshoes({
            ref_img: imageUrl
        })
        if (res.code != 0) throw new Error(res.message)
        return `${SEGMENT_ALGO_TYPE.AISHOES_MASK}:${res.data}`
    } catch (err) {
        console.log(err)
        message.warning(err?.message)
        return false
    }
}
// 获取同版型试衣上传图maskid
const getSimMaskId = async (imageUrl) => {
    try {
        const res = await API.maskPredictionAicloth({
            image: imageUrl,
            mask_style: 3,
        })
        if (res.code != 0) throw new Error(res.message)
        return `${SEGMENT_ALGO_TYPE.AISIM_MASK}:${res.data}`
    } catch (err) {
        console.log(err)
        message.warning(err?.message)
        return false
    }
}
// 获取模特maskId
const getModelMaskId = async (imageUrl, body = false) => {
    try {
        const res = await API.maskPrediction({
            image: imageUrl,
            mask_style: 4
        })
        if (res.code != 0) throw new Error(res.message)
        return body ? `${SEGMENT_ALGO_TYPE.AIMODEL_BODY_MASK}:${res.data}` : `${SEGMENT_ALGO_TYPE.AIMODEL_MASK}:${res.data}`
    } catch (err) {
        console.log(err)
        message.warning(err?.message)
        return false
    }
}
// 获取商品maskId
const getGoodsMaskId = async (imageUrl) => {
    try {
        const res = await API.maskPredictionGoods({
            image: imageUrl,
            mask_style: 4
        })
        if (res.code != 0) throw new Error(res.message)
        return `${SEGMENT_ALGO_TYPE.AIGOODS_MASK}:${res.data}`
    } catch (err) {
        console.log(err)
        message.warning(err?.message)
        return false
    }
}
// 取衣服或人多语义分割ID
const getSemanticClothMaskId = async (imageUrl) => {
    try {
        const res = await API.maskMultiSemanticPrediction({
            cloth_type: -1,
            image_path: imageUrl
        })
        if (res.code != 0) throw new Error(res.message)
        return `${SEGMENT_ALGO_TYPE.SEMANTIC_CLOTH_MASK}:${res.data}`
    } catch (err) {
        console.log(err)
        message.warning(err?.message)
        return false
    }
}
// 取同版型试衣素材多语义分割ID
const getSemanticSimTryonMaskId = async (imageUrl) => {
    try {
        const res = await API.maskMultiSemanticPrediction({
            cloth_type: 0, //只分上下装、连体衣服 mask_label == 0：上装 1：下装 2：套装 3：连体
            image_path: imageUrl
        })
        if (res.code != 0) throw new Error(res.message)
        return `${SEGMENT_ALGO_TYPE.SEMANTIC_SIMTRYON_MASK}:${res.data}`
    } catch (err) {
        console.log(err)
        message.warning(err?.message)
        return false
    }
}
const getSemanticSimTryonMaskIdClothTypeAll = async (imageUrl) => {
    try {
        const res = await API.maskMultiSemanticPrediction({
            cloth_type: -1, //取全label结果
            image_path: imageUrl
        })
        if (res.code != 0) throw new Error(res.message)
        return `${SEGMENT_ALGO_TYPE.SEMANTIC_SIMTRYON_MASK}:${res.data}`
    } catch (err) {
        console.log(err)
        message.warning(err?.message)
        return false
    }
}
// 输入图获取npy算法id
const getInteractiveNpyId = (inputImage, maskImage) => {
    return API.aiinteractivePrediction({
        img_path: inputImage,
        mask_path: maskImage,
        points_json: JSON.stringify([{ x: 0, y: 0, label: 1 }]),
        img_embedding_path: '',
        logits_path: ''
    }).then((res) => {
        if (res.code != 0) throw new Error(res.message)
        return res.data
    }).catch((err) => {
        console.log(err)
        message.warning(err?.message)
    })
}
// 输入图获取mask
const getClothMaskOutput = (id, stopCondition) => {
    const ids = id.split(":")
    const algoType = ids[0]
    const algoId = ids.length == 1 ? ids[0] : ids[1]
    return new Promise((resolve, reject) => {
        const loopCheck = () => {
            let url = algoType == SEGMENT_ALGO_TYPE.AISHOES_MASK ? API.maskPredictionshoesUrl + algoId :
                algoType == SEGMENT_ALGO_TYPE.AIMODEL_MASK ? API.maskPredictionUrl + algoId :
                    algoType == SEGMENT_ALGO_TYPE.AIMODEL_BODY_MASK ? API.maskPredictionUrl + algoId :
                        algoType == SEGMENT_ALGO_TYPE.AICLOTH_MASK ? API.maskPredictionAiclothUrl + algoId :
                            algoType == SEGMENT_ALGO_TYPE.AIGOODS_MASK ? API.maskPredictionUrlGoods + algoId :
                                algoType == SEGMENT_ALGO_TYPE.SEMANTIC_CLOTH_MASK ? API.multiSemanticPredictionUrl + algoId :
                                    null
            if (!url) reject(new Error('算法类型错误'))
            axios.post(url, {}, {
                headers: {
                    'Content-type': 'application/json',
                    'Ps-Auth-Token': localStorage.getItem('token')
                }
            }).then((res) => {
                if ((res.data.code == 0 && res.data.data.status == 'succeeded')) {
                    if (algoType == SEGMENT_ALGO_TYPE.AISHOES_MASK) {
                        const output1 = res.data.data.output[1]
                        const output2 = res.data.data.output[2]
                        const output3 = res.data.data.output[3]
                        resolve({
                            foregroundAlphaMask: output1,
                            binaryMask: output2,
                            foregroundMask: output3,
                        })
                    } else if (algoType == SEGMENT_ALGO_TYPE.AIMODEL_MASK) {
                        const output1 = res.data.data.output[1]
                        const output2 = res.data.data.output[2]
                        // const output3 = res.data.data.output[3]
                        const output4 = res.data.data.output[4]
                        resolve({
                            foregroundAlphaMask: output1,
                            foregroundMask: output2,
                            binaryMask: output4,
                        })
                    } else if (algoType == SEGMENT_ALGO_TYPE.AIMODEL_BODY_MASK) {
                        // const output1 = res.data.data.output[1]
                        // const output2 = res.data.data.output[2]
                        const output3 = res.data.data.output[3]
                        // const output4 = res.data.data.output[4]
                        resolve({
                            binaryMask: output3,
                        })
                    } else if (algoType == SEGMENT_ALGO_TYPE.AICLOTH_MASK) {
                        const output1 = res.data.data.output[1]
                        const output2 = res.data.data.output[2]
                        // const output3 = res.data.data.output[3]
                        const output4 = res.data.data.output[4]
                        resolve({
                            foregroundAlphaMask: output1,
                            foregroundMask: output2,
                            binaryMask: output4,
                        })
                    } else if (algoType == SEGMENT_ALGO_TYPE.AIGOODS_MASK) {
                        const output1 = res.data.data.output[1]
                        const output2 = res.data.data.output[2]
                        const output3 = res.data.data.output[3]
                        const output4 = res.data.data.output[4]
                        resolve({
                            foregroundAlphaMask: output1,
                            foregroundMask: output2,
                            trimmedMask: output3,
                            binaryMask: output4,
                        })
                    } else if (algoType == SEGMENT_ALGO_TYPE.SEMANTIC_CLOTH_MASK) {
                        // 取值顺序
                        // 上半身衣服：14、15、16
                        // 下半身衣服：20、21
                        // 连衣裙/连体衣：12、13
                        const output = res.data.data.output
                        const binaryMask = output.find(item => (
                            item.mask_label == "14" || item.mask_label == "15" || item.mask_label == "16" ||
                            item.mask_label == "20" || item.mask_label == "21" ||
                            item.mask_label == "12" || item.mask_label == "13"
                        ))?.image_path
                        resolve({
                            binaryMask,
                        })
                    }
                } else if (res.data.code == 0 && res.data.data.status == 'failed') {
                    reject(new Error(res.data.data.errcode))
                } else if (res.data.code != 0) {
                    reject(new Error(res.data.message))
                } else {
                    if (stopCondition && stopCondition()) return resolve()
                    setTimeout(() => {
                        loopCheck()
                    }, 400)
                }
            })
        }
        loopCheck()
    })
}
// 获取模型颜色mask
const getModelColorMaskId = (inputImage) => {
    return API.multiSemanticPrediction({
        image_path: inputImage,
        cloth_type: 0,
    }).then((res) => {
        if (res.code != 0) throw new Error(res.message)
        return `${SEGMENT_ALGO_TYPE.SEMANTIC_COLOR_MASK}:${res.data}`
    }).catch((err) => {
        console.log(err)
        message.warning(err?.message)
    })
}
// 获取颜色mask
const getColorMaskOutput = (id, stopCondition) => {
    const ids = id.split(":")
    // const algoType = ids.length > 1 ? ids[0] : SEGMENT_ALGO_TYPE.SEMANTIC_COLOR_MASK
    const algoId = ids.length == 1 ? ids[0] : ids[1]
    return new Promise((resolve, reject) => {
        const loopCheck = () => {
            let url = API.multiSemanticPredictionUrl + algoId
            axios.post(url, {}, {
                headers: {
                    'Content-type': 'application/json',
                    'Ps-Auth-Token': localStorage.getItem('token')
                }
            }).then((res) => {
                if ((res.data.code == 0 && res.data.data.status == 'succeeded')) {
                    const output = res.data.data.output
                    const imagePath = output?.find(item => item.mask_label == 'color_mask')?.image_path || null
                    resolve(imagePath)
                } else if (res.data.code == 0 && res.data.data.status == 'failed') {
                    reject(new Error(res.data.data.errcode))
                } else if (res.data.code != 0) {
                    reject(new Error(res.data.message))
                } else {
                    if (stopCondition && stopCondition()) return resolve()
                    setTimeout(() => {
                        loopCheck()
                    }, 200)
                }
            })
        }
        loopCheck()
    })
}
// 获取模型推荐筛选条件
const getModelRecommendFilter = async (imageUrl, stopCondition) => {
    const getModelRecommendFilterResult = (id) => {
        return new Promise((resolve, reject) => {
            const loopCheck = () => {
                let url = API.handlePredictionUrl + id
                axios.post(url, {}, {
                    headers: {
                        'Content-type': 'application/json',
                        'Ps-Auth-Token': localStorage.getItem('token')
                    }
                }).then((res) => {
                    if ((res.data.code == 0 && res.data.data.status == 'succeeded')) {
                        resolve(res.data.data.output)
                    } else if (res.data.code == 0 && res.data.data.status == 'failed') {
                        reject(new Error(res.data.data.errcode))
                    } else if (res.data.code != 0) {
                        reject(new Error(res.data.message))
                    } else {
                        if (stopCondition && stopCondition()) return resolve()
                        setTimeout(() => {
                            loopCheck(id)
                        }, 200)
                    }
                })
            }
            loopCheck()
        })
    }
    try {
        const res = await API.handlePrediction({
            img_path: imageUrl,
            ord_scale: 0.75,
            rentai_flag: 0, // type == IMAGE_TYPE.DRESSFORM? 1: 0
        })
        if (res.code != 0) throw new Error(res.message)
        const output = await getModelRecommendFilterResult(res.data)
        if (!output) return
        // 分别是性别、年龄
        let filter = {}
        const output6 = output[6] // 性别 
        const output7 = output[7] // 年龄 0-male 1-female
        if (output7) {
            const age = output7[0] > 15 ? "adult" : "children"
            const sex = age == "adult" ? (output6 == 1 ? "female" : "male") : "" // 只有成人才会有性别
            filter = sex ? { sex: [sex], age: [age] } : { age: [age] }
        }
        return filter
    } catch (err) {
        if (!err) return false
        console.error('maskFun fail', err)
        // const error = Utils.parseErrorCode(`[${err.message}]`)
        // eventBus.emit('notification', '提醒', error.message, 'error', error.code)
        // return false
        message.warning(err.message)
        return false
    }
}
// 获取商品推荐筛选条件
const getCommodityRecommendFilter = async (imageUrl, mask) => {
    try {
        const res = await API.getCommodityCategory({ image: imageUrl, mask: mask })
        if (res.code != 0) throw new Error(res.message)
        return res.data[0]
    } catch (err) {
        console.error('getCommodityRecommendFilter fail', err)
        message.warning(err.message)
        return false
    }
}
// 获取智能擦除
const getAiRemove = async (img, mask, stopCondition) => {
    const getAiRemoveResult = (id) => {
        return new Promise((resolve, reject) => {
            const loopFunc = () => {
                axios.post(API.airemovePredictionUrl + id, {}, {
                    headers: {
                        'Content-type': 'application/json',
                        'Ps-Auth-Token': localStorage.getItem('token')
                    }
                }).then(res => {
                    if ((res.data.code == 0 && res.data.data.status == 'succeeded')) {
                        resolve(res.data.data.output[1])
                    } else if (res.data.code == 0 && res.data.data.status == 'failed') {
                        reject(new Error(res.data.data.errcode))
                    } else {
                        if (stopCondition && stopCondition()) return resolve()
                        setTimeout(() => {
                            loopFunc()
                        }, 400)
                    }
                })
            }
            loopFunc()
        })
    }
    try {
        const res = await API.airemovePrediction({
            img_path: img,
            mask_path: mask,
            seed: -1
        })
        if (res.code != 0) throw new Error(res.message)
        const output = await getAiRemoveResult(res.data)
        return output
    } catch (err) {
        if (!err) return false
        console.error('getAiRemove fail', err)
        message.warning(err.message)
        return false
    }
}
// 获取衣物类型
const getClothType = async (imageUrl) => {
    try {
        const res = await API.getClothType({
            imageUrl: imageUrl,
        })
        if (res.code != 0) throw new Error(res.message)
        return res.data
    } catch (err) {
        console.log(err)
        message.warning(err?.message)
    }
}
// 获取多语义结果ID
export const getMultiSemanticId = (inputImage, cloth_type = -1) => {
    return API.multiSemanticPrediction({
        image_path: inputImage,
        cloth_type: cloth_type,
    }).then(res => {
        if (res.code != 0) throw new Error(res.message)
        return res.data
    }).catch((err) => {
        if (!err) return
        console.log(err)
        message.error(err.message)
    })
}
// 取多语义分割结果
export const getMultiSemanticOutput = (id, stopCondition) => {
    return new Promise((resolve, reject) => {
        const loopFunc = () => {
            let url = API.multiSemanticPredictionUrl + id
            axios.post(url, {}, {
                headers: {
                    'Content-type': 'application/json',
                    'Ps-Auth-Token': localStorage.getItem('token')
                }
            }).then(async (res) => {
                if ((res.data.code == 0 && res.data.data.status == 'succeeded')) {
                    resolve({
                        id,
                        output: res.data.data.output,
                    })
                } else if (res.data.code == 0 && res.data.data.status == 'failed') {
                    const error = Utils.parseErrorCode(`[${res.data.data.errcode}]`)
                    eventBus.emit('notification', '分割失败', error.message, 'error', error.code)
                    reject()
                } else {
                    if (stopCondition && stopCondition()) return resolve()
                    setTimeout(() => {
                        loopFunc()
                    }, 400)
                }
            })
        }
        loopFunc()
    })
}

export default {
    getClothMaskId,
    getShoesMaskId,
    getGlassesMaskId,
    getSimMaskId,
    getSemanticSimTryonMaskId,
    getSemanticSimTryonMaskIdClothTypeAll,
    getModelMaskId,
    getGoodsMaskId,
    getSemanticClothMaskId,
    getInteractiveNpyId,
    getClothMaskOutput,
    getModelColorMaskId,
    getColorMaskOutput,
    getModelRecommendFilter,
    getCommodityRecommendFilter,
    getAiRemove,
    getClothType,
    getMultiSemanticId,
    getMultiSemanticOutput,
}